import { SET_CLIENT_BRAND, VALIDATE_LANGUAGE_HASH } from "./types";
import store from "../store";
import { setAlert } from "./alertActions";
import axios from "axios";
import { I18n } from "react-redux-i18n";

// Fetch brand details - uses apikey to distinguish brands
export const fetchBrand = () => (dispatch, getState) => {
  return axios
    .get("/api/private/config/customization")
    .then((res) => {
      /* i'll get the translation hash from the customization endpoint, i'll check if its different from the current 
      hash saved in the redux storage, if its different i'll toggle the need update variable */

      let mostRecentHash = res.data.language.translationHash;
      let currentHash = store.getState()?.language?.translationHash;
      let translationNeedsReload = mostRecentHash === currentHash;

      dispatch({
        type: VALIDATE_LANGUAGE_HASH,
        payload: {
          translationNeedsReload: !translationNeedsReload,
          hash: currentHash,
        },
      });

      dispatch({
        type: SET_CLIENT_BRAND,
        payload: res.data,
      });
      return getState();
    })
    .catch((err) => {
      if (err && err.response && err.response.data && err.response.data.code)
        dispatch(setAlert(I18n.t(err.response.data.message), "danger"));

      if (axios.isCancel(err)) console.log("axios", err);
      else console.log(err);
    });
};
